import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type SetFolderColorsMutationVariables = Types.Exact<{
  input: Types.SetFolderColorsInput;
}>;


export type SetFolderColorsMutation = { __typename?: 'Mutation', setFolderColors?: { __typename: 'SetFolderColorsPayload' } | null };


export const SetFolderColors = /*#__PURE__*/ gql`
    mutation SetFolderColors($input: SetFolderColorsInput!) {
  setFolderColors(input: $input) {
    __typename
  }
}
    ` as unknown as DocumentNode<SetFolderColorsMutation, SetFolderColorsMutationVariables>;

          

          export const useSetFolderColorsMutation = (options?:MutationHookOptions<SetFolderColorsMutation, SetFolderColorsMutationVariables>) => useMutation(SetFolderColors, options);
          

          export type SetFolderColorsMutationOptions = MutationHookOptions<SetFolderColorsMutation, SetFolderColorsMutationVariables>;

          

          export type SetFolderColorsMutationResult = ReturnType<typeof useSetFolderColorsMutation>[1];

          
